// This file contains functions to manage URL parameters for the permit page.

import { SUBPERMIT_TAB_KEYS } from 'Config/config'

export const updateUrlTabParam = value => {
  const tabParamName = SUBPERMIT_TAB_KEYS[value]

  const urlParams = new URLSearchParams(window.location.search)
  if (tabParamName) {
    urlParams.set('tab', tabParamName)
  } else {
    urlParams.delete('tab')
  }

  let newUrl = `${window.location.pathname}`

  // Remove the "?" from the URL if no params
  const queryString = urlParams.toString()
  if (queryString) {
    newUrl += `?${queryString}`
  }

  window.history.replaceState(null, '', newUrl)
}

export const getTabKeyFromParams = value => {
  const urlParams = new URLSearchParams(window.location.search)
  const tabParamName = urlParams.get('tab')

  const tabKey = Object.keys(SUBPERMIT_TAB_KEYS).find(
    key => SUBPERMIT_TAB_KEYS[key] === tabParamName
  )

  return tabKey || undefined
}
